// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".select[data-v-2c5755d7] {\n  box-shadow: inset 0 0 0 1px #c6c6c6;\n}\n.select[disabled][data-v-2c5755d7], .select.is-disabled[data-v-2c5755d7] {\n  color: #e4e4e4;\n  box-shadow: inset 0 0 0 1px transparent;\n}\n\n.icon[disabled][data-v-2c5755d7], .icon.is-disabled[data-v-2c5755d7] {\n  color: var(--magic-disabled, #e4e4e4);\n}", ""]);
// Exports
module.exports = exports;
